<template>
  <div v-if="!isEmpty" class="mt-3">
    <div class=" p-3">
      <div class="row mb-3">
        <div class="col">
          <em
            class="fas fa-user-alt rounded-circle shadow p-2 color-primary-2 mr-2"
          />
          <span>Practicantes/Internos/Especialistas Seleccionados</span>
        </div>
      </div>
    </div>
    <div v-for="specialist in specialists" :key="specialist.supervisedId">
      <custom-callout class="mb-3">
        <div class="row">
          <div class="col-sm">
            <span class="data-name">Tipo:</span>
            <p class="data">{{ specialist.supervisedTypeName }}</p>
          </div>
          <div class="col-sm">
            <span class="data-name">Nombre:</span>
            <p class="data">{{ specialist.specialistName }}</p>
          </div>
          <div class="col-sm">
            <span class="data-name">Número Seguro Social:</span>
            <p class="data">{{ specialist.socialSecurity }}</p>
          </div>
          <div class="col-sm">
            <span class="data-name">Especialidad(es):</span>
            <p class="data">{{ specialist.specialist_DisciplineName }}</p>
          </div>
          <div v-if="!disabled" class="col-sm">
            <div class="col d-flex justify-content-end mt-3">
              <action-button
                i="fa fa-times-circle"
                text="Remover"
                variant="outline-danger"
                @click="removeSpecialist(specialist.supervisedId)"
              />
            </div>
          </div>
        </div>
      </custom-callout>
    </div>
    <pagination
      v-if="showPagination"
      :data="pagination"
      @pagination-go-page="currentPage = $event"
    />
  </div>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import Pagination from '@/components/common/Pagination';

export default {
  name: '',
  components: {
    CustomCallout,
    Pagination,
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
      meta: {
        description: 'Arreglo de especialistas',
        example: '[{}]',
      },
    },
    onRemoveSpecialist: {
      type: Function,
      default: () => undefined,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      currentPage: 1,
      count: 5,
    };
  },
  computed: {
    isEmpty() {
      return this.value && this.value.length === 0;
    },
    specialists() {
      let since = (this.currentPage - 1) * this.count;
      let until = since + this.count;
      return this.value.slice(since, until);
    },
    pagination() {
      return {
        currentPage: this.currentPage,
        totalItemCount: (this.value || []).length,
        pageCount: Math.ceil((this.value || []).length / this.count),
        count: this.count,
      };
    },
    showPagination() {
      return this.value.length > this.count;
    },
  },
  watch: {
    specialists(value) {
      if (value.length == 0) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    removeSpecialist(specialistId) {
      this.onRemoveSpecialist(specialistId);
    },
  },
};
</script>
